import { App } from 'vue'
import GuidedTour from './LpGuidedTour.vue'

GuidedTour.install = (Vue: App) => {
  Vue.component(GuidedTour.name, GuidedTour)
}

export default GuidedTour
